import {defineMessage} from 'react-intl';
import {view} from '@sail/ui';
import {more} from '@sail/icons/react/Icon';
import {HeaderButton, Placement} from './HeaderButton';

const moreLabel = defineMessage({
  id: 'conversations_ui.widget.header.moreButton.label',
  description: 'Label used for the overflow menu header button.',
  defaultMessage: 'More actions',
});

type Props = {
  tooltipPlacement?: Placement;
};

export function HeaderMenuButton({tooltipPlacement = 'bottom right'}: Props) {
  return (
    <view.div>
      <HeaderButton
        testId="conversations-widget-header-more"
        icon={more}
        label={moreLabel}
        tooltipPlacement={tooltipPlacement}
        rotateIcon
      />
    </view.div>
  );
}
